<script>

import ExhibitorRow from "./exhibitor-row.vue"
import CategoryNavbar from "./category-navbar.vue"
import FavoriteMixin from "./favorite-mixin.js"
import PaginationButtons from "../pagination-buttons.vue"

export default {
  components: {ExhibitorRow, CategoryNavbar, PaginationButtons},
  mixins: [FavoriteMixin],
  props: {
    eventShortName: {type: String },
    listDisplay: {type: Boolean, default: true},
  },

  data() {
    return {
      filter: {},
      currentNode: null,
      tree: null,
      loading: false,
      exhibitors: [],
      numExhibitors: 0,
      numPages: 0,
      exhibitorType: 'exhibitor',
      page: (this.$route && this.$route.query.page) || new URLSearchParams(window.location.search).get('page') || 1,
    }
  },

  computed: {
    favoriteMode() { return this.eventShortName == undefined || !navigator.onLine },

    nodes() {
      const filterExhibitorNodes = (nodes) => {
        return nodes
          .map(node => {
            // filter childs recursive
            const filteredChildren = filterExhibitorNodes(node.children || []);
            const hasExhibitors = node.nexhibitors > 0;

            // keep only, if self or a child has nexhbitiors > 0
            if (hasExhibitors || filteredChildren.length > 0) {
              return {
                ...node,
                children: filteredChildren
              };
            }
            return null;
          })
          .filter(Boolean); // removes null entries
      };

      let currentNode = this.currentNode ? this.currentNode : this.tree

      // if currentNode null or has no childs
      if (!currentNode || !currentNode.children) return []

      return filterExhibitorNodes(currentNode.children)
    },

    breadcrumbs() {
      if (!this.currentNode) return [ {name: 'X', id: -1}]

      const breadcrumbs = [];
      let currentNode = this.currentNode;

      while (currentNode) {
        breadcrumbs.unshift(currentNode);
        const parentNode = this.findNodeById(this.tree, currentNode.parent);
        currentNode = parentNode;
      }
      return breadcrumbs;
    },
  },

  watch: {
    filter: {
      handler(newValue) {
        this.page = 1
        this.filter = newValue
        this.fetchExhibitors(newValue)
        let query = this.filter.search ? {search: this.filter.search} : {}
        if (this.currentNode && this.currentNode.id != -1)
          query.category = String(this.currentNode.id)
        if (this.filter.favorites)
          query.favorites = "1"
        if (this.filter.for_me)
          query.for_me = "1"
        this.$router.push({query: query}).catch(err => {
          // catch NavigationDuplicated
          console.error(err)
        });
      },
      deep: true
    },
    page: {
      handler(newValue) {
        this.fetchExhibitors({page: newValue, ...this.filter})
        // persist page in URL so browser-back restores it
        let query = {...this.$route.query}
        if (newValue > 1) query.page = newValue
        else delete query.page
        this.$router.replace({query}).catch(() => {})
      },
    },
  },

  created() {
    const q = this._urlQuery()

    if (q.search) this.filter.search = q.search
    if (q.favorites) this.filter.favorites = "1"
    if (q.for_me) this.filter.for_me = 1

    let me = this
    this.fetchCategories().then(() => {
      const categoryId = q.category || q.categories__id
      if (categoryId) {
        let node = me.findNodeById(me.tree, parseInt(categoryId))
        if (node) me.onFilterCategory(node)
        else me.fetchExhibitors({page: me.page, ...me.filter})
      } else {
        me.fetchExhibitors({page: me.page, ...me.filter})
      }
    })
  },

  methods: {

    onCategoryClickedFromRow(cat) {
      const node = this.tree ? this.findNodeById(this.tree, cat.id) : null
      if (node) this.onFilterCategory(node)
    },

    _urlQuery() {
      const params = new URLSearchParams(window.location.search)
      const fromUrl = {}
      params.forEach((v, k) => { fromUrl[k] = v })
      return Object.assign(fromUrl, (this.$route && this.$route.query) || {})
    },

    findNodeById(node, targetId) {
      if (node.id === targetId) {
        return node;
      }

      for (const child of node.children) {
        const foundNode = this.findNodeById(child, targetId);
        if (foundNode) {
          return foundNode;
        }
      }
      return null;
    },

    collect_all_ids(node, idList) {
      idList.push(node.id)
      for (let child of node.children) {
          this.collect_all_ids(child, idList)
      }
      return idList
    },

    onFilterCategory: function (node) {
      if (node.id == -1 && this.currentNode == null) return
      this.filter.search = ''
      this.$delete(this.filter, 'search')
      this.$delete(this.filter, 'company__name__gt')
      if (node.id == -1) {
        this.currentNode = null
        this.$delete(this.filter, 'categories__id')
      } else {
        this.currentNode = node
        var idList = []
        this.collect_all_ids(node, idList)
        this.$set(this.filter, 'categories__id', idList.join())
      }
    },

    onFilterValue: function (value) {
      this.filter.search = ''
      this.$delete(this.filter, 'search')
      if (value) {
        if (value == '#') value = '0'
        this.$set(this.filter, 'company__name__gt', value)
      } else
        this.$delete(this.filter, 'company__name__gt')
    },

    toggleForMe: function () {
      if (this.filter.for_me) {
        this.$delete(this.filter, 'for_me')
      } else {
        // "for me" overrides manual category / letter selection
        this.currentNode = null
        this.$delete(this.filter, 'categories__id')
        this.$delete(this.filter, 'company__name__gt')
        this.$delete(this.filter, 'search')
        this.$set(this.filter, 'for_me', 1)
      }
    },

    onSearchChanged: function (search) {
        this.currentNode = null
        this.$delete(this.filter, 'categories__id')
        this.$delete(this.filter, 'company__name__gt')
        if (search) this.$set(this.filter, 'search', search)
        else this.$delete(this.filter, 'search')
    },

    resetFilter: function () {
      this.$delete(this.filter, 'search')
      this.$delete(this.filter, 'categories__id')
      this.currentNode = null
    },

    showDescription: function(exhibitor) {
      this.$set(exhibitor, 'show_desc',  exhibitor.show_desc == undefined ? 1 : !exhibitor.show_desc)
    },

    fetchCategories: function () {
      if (this.favoriteMode)
        return Promise.resolve({data:[]})

      let me =  this
      let params = {}
      if (!this.favoriteMode) params.event__short_name = this.eventShortName.toUpperCase()
      return this.$api.get(`/exhibitor-categories/`, {params: params}).then(response => {
        me.tree = {id:-1, name: 'X', children: response.data, parent:null}
        for (let node of me.tree.children) node.parent = -1
        return response
      })
    },

    fetchExhibitors: function (filter) {
      let me =  this
      let params = {...filter}
      let payload = {}
      if (this.favoriteMode) {
        if (this.getFavorites().length < 1) {
          me.exhibitors = []
          me.numExhibitors = 0
          me.numPages = 1
          return
        }
      } else {
        params.event__short_name = this.eventShortName.toUpperCase()
        if (params.favorites) {
          delete params.favorites
          payload.sfid = this.getFavorites()
        }
      }
      if (navigator.onLine) {
        me.loading = true
        return this.$api.post(`/exhibitor-product-index/`, payload, {params: params,}).then(
          response => {
          me.exhibitors = response.data.results
          me.numExhibitors = response.data.count
          me.numPages = response.data.num_pages
          return response
        }).finally(() => { me.loading = false })
      } else {
        me.exhibitors = Object.values(this.$storage.getItem('exhibitors', {}))
        me.numExhibitors = me.exhibitors.length
        me.numPages = 1
      }
    },

  },
}
</script>

<template>
  <div>
    <category-navbar v-if="nodes" class="mb-1"
      :filter="filter"
      :nodes="nodes"
      fav-key="sfid"
      @search="onSearchChanged($event)" 
      @delete-search="resetFilter()"
      @on-filter-node="onFilterCategory($event)"
      @on-filter-value="onFilterValue($event)"
      @toggle-favorites="toggleFavorites($event)"
      @toggle-for-me="toggleForMe()"
    />

    <ol class="breadcrumb bg-white ps-0">
      <li v-for="(crumb, index) in breadcrumbs" :key="index"
       class="breadcrumb-item" :class="{active: index + 1 == breadcrumbs.length}">
        <a href="" @click.prevent="onFilterCategory(crumb)">{{ crumb.name }}</a>
      </li>
      <li v-if="filter.for_me" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none" @click.prevent="toggleForMe()">
          <b>Für mich&nbsp;</b><i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-show="currentNode || $route.query.search" class="text-muted">&nbsp;({{ numExhibitors }})</li>
    </ol>

    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <span v-else-if="exhibitors.length > 0">
      <div class="row mb-3">
        <div class="d-none d-lg-block col col-lg-3">
          <div v-for="node in nodes" :key="node.id">
            <a class="no-deco" href="" @click.prevent="onFilterCategory(node)">{{ node.name }}</a></div>
        </div>
        <div class="col col-12 col-md-9">
          <div v-for="exhibitor in exhibitors" :key="exhibitor.id">
            <exhibitor-row :exhibitor="exhibitor" :listDisplay="listDisplay"
              @category-clicked="onCategoryClickedFromRow($event)" />
            <hr/>
          </div>
        </div>
      </div>

      <pagination-buttons :page.sync="page" :num-pages="numPages" />
    </span>
    <div v-else class="mb-3">
      <div class="text-center">-- keine Treffer --</div>
    </div>
  </div>

</template>

<style scoped>
.breadcrumb-item a {
  text-decoration: none;
  font-size: 90%;
}

.no-deco {
  text-decoration: none;
}
</style>